import { Grid, Pagination } from '@mui/material';
import React from 'react';
import { gridSpacing } from '../../store/constant';

export default function AppPagination({ data = [], onChangePage = () => {}, totalPages = 0, page }) {
    if (data.length === 0) {
        return <></>;
    }

    return (
        <Grid item xs={12} sx={{ p: 3 }}>
            <Grid container justifyContent="space-between" spacing={gridSpacing}>
                <Grid item>
                    <Pagination count={totalPages} color="primary" onChange={onChangePage} {...(page ? { page } : {})} />
                </Grid>
            </Grid>
        </Grid>
    );
}
